import { EducationLevel, educationLevelsWithLearningPaths, educationLevelsWithSubLevels } from '../../../../models/EducationLevels';
import { SchoolExperienceFormData } from '../../../../models/SchoolExperience/SchoolExperience';
import {
    FormErrors,
    FormValidation,
    validateEndDate,
    validateForm,
    validateRequiredString,
    validateStartDate,
} from '../../../../services/ValidationService';

export type SchoolExperienceFormErrors = FormErrors<SchoolExperienceFormData>;

export const validateSchoolExperienceFormData = (
    formData: SchoolExperienceFormData,
): FormValidation<SchoolExperienceFormErrors> => {
    const dateNotation = 'MMMM yyyy';

    const educationSubLevelIsRequired = educationLevelsWithSubLevels.includes(formData.educationLevel as EducationLevel);
    const learningPathIsRequired = educationLevelsWithLearningPaths.includes(formData.educationLevel as EducationLevel);

    const errors: SchoolExperienceFormErrors = {
        educationLevel: validateRequiredString('educationLevel', formData.educationLevel),
        educationSubLevel: educationSubLevelIsRequired
            ? validateRequiredString('educationSubLevel', formData.educationSubLevel)
            : undefined,
        learningPath: learningPathIsRequired
            ? validateRequiredString('learningPath', formData.learningPath)
            : undefined,
        fieldOfStudy: validateRequiredString('fieldOfStudy', formData.fieldOfStudy),
        school: validateRequiredString('school', formData.school),
        startDate: validateStartDate(formData.startDate, formData.endDate, dateNotation),
        endDate: validateEndDate(formData.endDate, formData.startDate, dateNotation),
    };

    return validateForm<SchoolExperienceFormErrors>(errors);
};
